.container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #F7F9FC;
}

.header {
  background-color: #635BFF;
  color: white;
  padding: 40px 0;
  margin-bottom: 30px;
  width: 100vw;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  position: relative;
}

.headerContent {
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;
}

.headerRow {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.logoContainer {
  display: flex;
  align-items: center;
  gap: 15px;
}

.logo {
  width: 40px;
  height: 40px;
}

.restaurantDescription {
  color: rgba(255, 255, 255, 0.8);
  font-size: 16px;
}

.secondaryButton {
  background-color: rgba(255, 255, 255, 0.2);
  color: white;
  border: none;
  border-radius: 6px;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.secondaryButton:hover {
  background-color: rgba(255, 255, 255, 0.3);
}

.content {
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px 40px;
}

.tabs {
  display: flex;
  margin-bottom: 30px;
  background-color: #f0f0f0;
  border-radius: 8px;
  overflow: hidden;
}

.tabButton {
  flex: 1;
  padding: 14px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
  font-size: 15px;
}

.activeTab {
  background-color: #635BFF;
  color: white;
}

.orderContainer {
  display: flex;
  min-height: 700px;
  gap: 30px;
  width: 100%;
}

.ordersList {
  flex: 2;
  background-color: white;
  border-radius: 12px;
  padding: 25px;
  overflow-y: auto;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.ordersListTitle {
  margin-top: 0;
  margin-bottom: 20px;
  color: #2D3748;
  font-size: 20px;
}

.loadingState {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
}

.loadingSpinner {
  width: 40px;
  height: 40px;
  border: 3px solid #E2E8F0;
  border-top-color: #635BFF;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 15px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.emptyState {
  text-align: center;
  padding: 40px 0;
  color: #718096;
}

.orderCard {
  padding: 20px;
  margin-bottom: 15px;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  background-color: white;
  cursor: pointer;
  transition: all 0.2s ease;
}

.orderCard:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.selectedOrderCard {
  background-color: #EBF8FF;
  border-color: #4299E1;
}

.orderCardHeader {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  font-size: 16px;
}

.tableIndicator {
  color: #718096;
}

.orderAmount {
  font-weight: 600;
}

.orderCardFooter {
  display: flex;
  justify-content: space-between;
  font-size: 15px;
  color: #718096;
}

.orderDetails {
  flex: 3;
  background-color: #F7FAFC;
  border-radius: 12px;
  padding: 30px;
  overflow-y: auto;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.orderDetailHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
}

.orderDetailHeader h3 {
  margin: 0;
  color: #2D3748;
  font-size: 22px;
}

.statusBadge {
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  color: white;
}

.customerInfo {
  margin-bottom: 25px;
  line-height: 1.8;
  font-size: 16px;
}

.paymentStatus {
  margin-top: 5px;
}

.orderItemsSection {
  margin-top: 25px;
}

.orderItemsSection h4 {
  margin-top: 0;
  margin-bottom: 15px;
  color: #2D3748;
  font-size: 18px;
}

.orderItemsList {
  list-style: none;
  padding: 0;
  margin: 0;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.orderItem {
  padding: 15px 20px;
  border-bottom: 1px solid #EDF2F7;
}

.orderItem:last-child {
  border-bottom: none;
}

.orderItemHeader {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
}

.itemQuantity {
  font-weight: bold;
  margin-right: 12px;
}

.itemNotes {
  margin-top: 8px;
  font-size: 15px;
  color: #718096;
}

.orderTotal {
  margin-top: 25px;
  padding-top: 15px;
  border-top: 2px solid #EDF2F7;
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  font-size: 18px;
  color: #2D3748;
}

.orderActions {
  margin-top: 35px;
}

.orderActions h4 {
  margin-top: 0;
  margin-bottom: 15px;
  color: #2D3748;
  font-size: 18px;
}

.actionButtons {
  display: flex;
  gap: 15px;
}

.primaryButton {
  flex: 1;
  background-color: #635BFF;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 20px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.primaryButton:hover {
  background-color: #574ce0;
}

.successButton {
  flex: 1;
  background-color: #48BB78;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 20px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.successButton:hover {
  background-color: #38A169;
}

.dangerButton {
  flex: 1;
  background-color: #F56565;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 20px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.dangerButton:hover {
  background-color: #E53E3E;
}

.noOrderSelected {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  color: #718096;
  font-size: 16px;
}

/* Responsive design */
@media (max-width: 768px) {
  .orderContainer {
    flex-direction: column;
    height: auto;
  }
  
  .ordersList, .orderDetails {
    max-height: 500px;
  }
}
/* Add these styles to your OrdersDashboard.module.css file */

/* Notification banner */
.notification {
  position: fixed;
  top: 20px;
  right: 20px;
  background-color: #635BFF;
  color: white;
  padding: 12px 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 12px;
  z-index: 1000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  animation: slideIn 0.3s ease-out;
}

.notification button {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  padding: 4px 8px;
  border-radius: 4px;
  color: white;
  cursor: pointer;
  font-size: 12px;
  margin-left: 10px;
}

.notification button:hover {
  background: rgba(255, 255, 255, 0.3);
}

@keyframes slideIn {
  from {
    transform: translateY(-100px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}